import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_classrooms_path } from '@/modules/routes';
import sortStudentsByFirstName from '../sortStudentsByFirstName';

interface NotifyStudentsStudent {
  first_name: string;
  id: number;
  last_name: string;
}

export interface NotifyStudentsClassroom {
  id: number;
  name: string;
  period: string;
  students: NotifyStudentsStudent[];
}

// AIDEV-NOTE: Match Teacher::ClassroomsController#index `.order(:period, :name)` so this
// modal renders classes in the same order as the teacher's class list page (PLAT-17262).
export const sortClassrooms = (classrooms: NotifyStudentsClassroom[]) => (
  [...classrooms].sort((a, b) => (
    a.period.localeCompare(b.period)
    || a.name.localeCompare(b.name)
    || a.id - b.id
  ))
);

// AIDEV-NOTE: PLAT-17342 — Sort students A-Z by first name within each classroom so
// teachers scanning the modal can find a student fast.
const sortClassroomsAndStudents = (classrooms: NotifyStudentsClassroom[]) => (
  sortClassrooms(classrooms).map(classroom => ({
    ...classroom,
    students: sortStudentsByFirstName(classroom.students),
  }))
);

export const useClassrooms = ({ programId, stafferId }: { programId: number, stafferId: number }) => (
  useQuery({
    enabled: !!(stafferId && programId),
    placeholderData: ([] as NotifyStudentsClassroom[]),
    queryFn: () => (
      axios
        .get<{ data: NotifyStudentsClassroom[] }>(
        plato_api_classrooms_path({
          for_program: programId,
          for_staffer: stafferId,
          include: ['students'],
          only: ['id', 'name', 'period', 'students'],
        }),
      )
        .then(res => sortClassroomsAndStudents(res.data.data))
    ),
    queryKey: ['classroom', programId, stafferId],
  })
);
